import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Studio } from '../models/studio';
import { ResourcefulService } from './resourcefulService';



@Injectable({
    providedIn: 'root'
})
export class StudioService extends ResourcefulService<Studio>{
    constructor(private httpClient: HttpClient) {
        super(httpClient, Studio);
    }
}
